/**
 * Fire-and-forget tier-gate intent tracker.
 *
 * Call `trackTierGate({ surface, ... })` whenever a user clicks an "Upgrade"
 * CTA or interacts with a locked feature. We don't await — analytics should
 * never block user navigation.
 *
 * Surfaces (keep these stable; the admin dashboard groups by surface):
 *  - subscription_button       — Crown pill in the navbar
 *  - lake_pro_card             — Pro intel locked panel on lake detail
 *  - competition_locked        — locked competition teaser CTA
 *  - recommendations_lock      — locked Smart Recommendations row
 *  - 402_response              — generic 402 caught by api client
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getToken = () => {
  try {
    return localStorage.getItem('carpcast_token');
  } catch {
    return null;
  }
};

export const trackTierGate = ({ surface, feature = null, requiredTier = null, metadata = null }) => {
  if (!surface) return;
  const token = getToken();
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  // Fire-and-forget: don't await, swallow errors silently
  axios
    .post(
      `${API}/analytics/tier-gate-event`,
      {
        surface,
        feature,
        required_tier: requiredTier,
        metadata,
      },
      { headers, timeout: 4000 },
    )
    .catch(() => {});
};
